import { render, staticRenderFns } from "./workCalendar.vue?vue&type=template&id=5af54bae&scoped=true"
import script from "./workCalendar.vue?vue&type=script&lang=js"
export * from "./workCalendar.vue?vue&type=script&lang=js"
import style0 from "./workCalendar.vue?vue&type=style&index=0&id=5af54bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af54bae",
  null
  
)

export default component.exports